module.exports = __webpack_public_path__ + "img/poison_desc.7671de57.jpg";